import { render, staticRenderFns } from "./postVideoUser.vue?vue&type=template&id=367b74b5&"
import script from "./postVideoUser.vue?vue&type=script&lang=js&"
export * from "./postVideoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports